import { formatDate } from '@angular/common';
import { UserNotification, UserNotificationType } from '@interfaces/Reminder';

export interface UserNotificationPresentation {
  title: string;
  message: string;
  icon: string;
}

export const getUserNotificationPresentation = (
  notification: UserNotification,
): UserNotificationPresentation => {
  switch (notification.type) {
    case UserNotificationType.SERVICE_REMINDER:
      return {
        title: `Recordatorio: ${notification.data['customerName'] || 'Cliente'} - ${notification.data['vehicleLicensePlate'] || 'Vehículo'}`,
        message: `Service estimado para ${formatDate(new Date(notification.eventDate), 'mediumDate', 'es-AR')}`,
        icon: 'build',
      };
    case UserNotificationType.CHECK_PAYABLE_SOON:
      return {
        title: 'Cheque próximo a fecha de pago/cobro',
        message: notification.data['message'],
        icon: 'event_note',
      };
    case UserNotificationType.CHECK_PAYABLE_NOW:
      return {
        title: 'Cheque disponible para presentar/cobrar',
        message: notification.data['message'],
        icon: 'payments',
      };
    case UserNotificationType.CHECK_PRESENTATION_DEADLINE_SOON:
      return {
        title: 'Próximo vencimiento de presentación',
        message: notification.data['message'],
        icon: 'schedule',
      };
    case UserNotificationType.CHECK_PRESENTATION_DEADLINE_PASSED:
      return {
        title: 'Presentación de cheque vencida',
        message: notification.data['message'],
        icon: 'warning',
      };
    default:
      return {
        title: 'Notificación',
        message: 'Tenés una nueva notificación.',
        icon: 'notifications',
      };
  }
};
